import FeedbackConst from "./FeedbackConst";
import ApplicationConst from "../../ApplicationConst";
import RequestEntity from "../../api/RequestEntity";
import BaseURL from "../../api/BaseURL";

const BASE_URL = BaseURL.getBaseURL() + "/";

const FeedbackActions = {

    startFeedbackTimer: (timer) =>{
        return {type: FeedbackConst.START_TIMER, payload: {timer: timer}}
    },

    startDownload: () => {
      return (dispatch, getState) => {
        let token = getState().application.token.token;
        return dispatch({type: ApplicationConst.AJAX_CALL, entity: new RequestEntity(BASE_URL + "api/feedback/request/" + token, "POST", FeedbackConst.START_DOWNLOAD)});
      }
    },
    startRequests:(interval) => {
        return {type: FeedbackConst.START_REQUESTS, payload:{interval:interval}}
    },
    //getDownloads: () => {
    //  return (dispatch, getState) => {
    //    let token = getState().application.token.token;
    //    return dispatch({type: ApplicationConst.AJAX_CALL, entity: new RequestEntity(BASE_URL + "api/feedback/request/" + token, "GET", FeedbackConst.RESULT_DOWNLOAD_FINISHED)})
    //  }
    //},
    setIndicatorInitial: (timespan) => {
      let RADIUS = 54;
      let CIRCUMFERENCE = 2 * Math.PI * RADIUS;
      return dispatch => {
        let interval = setInterval(()=>{dispatch(FeedbackActions.tick())}, 50);
        dispatch({type: "SET_INDICATOR_INITIAL", payload:{interval: interval, timer:0, strokeDashoffset: CIRCUMFERENCE, strokeDasharray: CIRCUMFERENCE, circumference: CIRCUMFERENCE, timespan: timespan}});
      }
    },
    setIndicatorTimer: (timer, strokeDashoffset) => {
      return {type: "SET_INDICATOR_TIMER", payload:{timer: timer, strokeDashoffset: strokeDashoffset}}
    },
    tick:() => {
      return {type: "SET_INDICATOR_TICK"}
    },
    saveDownloadStats:(language) => {
      return (dispatch, getState) => {
        let token = getState().application.token.token;
        return dispatch({type: ApplicationConst.AJAX_CALL, entity:new RequestEntity(BASE_URL + "api/feedback/statistic/" + token + "/" + language, "POST", "SAVE_DOWNLOAD_STATS")});
      }
    }

};

export default FeedbackActions;



// WEBPACK FOOTER //
// ./src/modules/feedback/FeedbackActions.js